import { getSpeciesTeeth } from "duck";
import { DentalChartEnum, SpeciesEnum } from "requests";

export const getPrevNext = (
  species: SpeciesEnum,
  milkOrAdultTeeth: DentalChartEnum,
  toothNumber: number
) => {
  const list = getSpeciesTeeth(species, milkOrAdultTeeth);
  const currentIndex = list.findIndex(val => val === toothNumber);

  return {
    prev: currentIndex === 0 ? list[list.length - 1] : list[currentIndex - 1],
    next: currentIndex === list.length - 1 ? list[0] : list[currentIndex + 1]
  };
};
